import type { CSSProperties } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { siteContent } from './content/loadContent';
import { AppShell } from './components/layout/app-shell';
import { ScrollToTop } from './components/layout/scroll-to-top';
import { usePageMeta } from './hooks/use-page-meta';
import { ContactPage } from './pages/contact-page';
import { FaqPage } from './pages/faq-page';
import { HomePage } from './pages/home-page';
import { NotFoundPage } from './pages/not-found-page';
import { PlaceholderPage } from './pages/placeholder-page';
import { PraxisPage } from './pages/praxis-page';
import { ReviewsPage } from './pages/reviews-page';
import { ServicesPage } from './pages/services-page';
import { TeamPage } from './pages/team-page';

function RoutedApp(): JSX.Element {
  usePageMeta(siteContent);

  return (
    <AppShell content={siteContent}>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage content={siteContent} />} />
        <Route path="/leistungen" element={<ServicesPage content={siteContent} />} />
        <Route path="/team" element={<TeamPage content={siteContent} />} />
        <Route path="/praxis" element={<PraxisPage content={siteContent} />} />
        <Route path="/bewertungen" element={<ReviewsPage content={siteContent} />} />
        <Route path="/faq" element={<FaqPage content={siteContent} />} />
        <Route path="/kontakt" element={<ContactPage content={siteContent} />} />
        <Route path="/karriere" element={<PlaceholderPage content={siteContent} type="karriere" />} />
        <Route path="/downloads" element={<PlaceholderPage content={siteContent} type="downloads" />} />
        <Route path="/impressum" element={<PlaceholderPage content={siteContent} type="legal" />} />
        <Route path="/datenschutz" element={<PlaceholderPage content={siteContent} type="legal" />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AppShell>
  );
}

export default function App(): JSX.Element {
  const palette = siteContent.theme.palette;
  const themeStyle: CSSProperties = {
    '--color-primary': palette.primary,
    '--color-primary-soft': palette.primarySoft,
    '--color-secondary': palette.secondary,
    '--color-accent': palette.accent,
    '--color-background': palette.background,
    '--color-surface': palette.surface,
    '--color-surface-alt': palette.surfaceAlt,
    '--color-text': palette.text,
    '--color-muted': palette.muted,
    '--color-border': palette.border,
    '--color-success': palette.success,
  } as CSSProperties;

  return (
    <div style={themeStyle}>
      <BrowserRouter>
        <RoutedApp />
      </BrowserRouter>
    </div>
  );
}
